import { HStack } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { NotificationCounter } from '../../common/components/notification-counter';
import { getUniversalSearchLabel } from '../../common/helpers/get-usx-labels';
import { useEnabledFeatures } from '../../common/hooks/enabled-features';
import { WorkspacePanelButton } from '../../panels/workspace-panel-button';
import { useDexNotification } from '../use-dex-notification';

export const DexResultsButton = observer(function DexResultsButton(): React.ReactElement {
    const { count = 0, isUrgent } = useDexNotification();
    const { dexNextEnabled } = useEnabledFeatures();

    return (
        <HStack style={{ position: 'relative' }}>
            <WorkspacePanelButton
                tooltipText={`${getUniversalSearchLabel(dexNextEnabled)} Results`}
                workspacePanelType="DATA_EXCHANGE_RESULTS"
                aria-label="open dex results"
                icon="DataExchangeResults"
            />
            <NotificationCounter
                isUrgent={isUrgent}
                button="dex-results"
                style={{
                    position: 'absolute',
                    right: '0',
                    top: '0',
                    transform: 'translate(25%, 3%)',
                }}
            >
                {count}
            </NotificationCounter>
        </HStack>
    );
});
